var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "podpis-event-banner"
  }, [_vm._m(0), _c('div', [_c('client-event-handler', {
    attrs: {
      "component": 'ContractSignEvent',
      "rules": ['single'],
      "title": 'Vytvoriť',
      "type": 'clientKnown',
      "client": _vm.client,
      "class-cst": 'text-cta bl-color'
    }
  })], 1)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "div-block-142"
  }, [_c('img', {
    staticClass: "image-10",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f39_calendar%20icon.png",
      "loading": "lazy",
      "width": "40",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "div-block-143"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v("Podpis úverových zmlúv")])])]);

}]

export { render, staticRenderFns }